import { Skeleton } from 'antd'
import React from 'react'


interface Props{
    loading?: boolean
    lines?:number
    children?: React.ReactNode
}

const SkeletonText = ({loading, children, lines}:Props) => {
  return (
    <>
    {loading? <Skeleton.Input active={true}  />
    
    : children
    }
    </>

  )
}

export default SkeletonText